export default "__VITE_ASSET__DtMciIIj__"